// extracted by mini-css-extract-plugin
export default {"tagBlock":"TitleBlock_tagBlock__2bev1"};